import * as React from "react";
import stores from "./stores";
import Routes from "./routes";
import {Provider} from "mobx-react";

class Root extends React.Component {
  wakeLock = null

  async componentDidMount() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
    await this.requestWakeLock()
  }

  componentWillUnmount() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    if (this.wakeLock) {
      console.log('releasing wakelock')
      this.wakeLock.release()
    }
  }

  handleVisibilityChange = async () => {
    if (this.wakeLock !== null && document.visibilityState === 'visible') {
      this.wakeLock = await this.requestWakeLock()
    }
  }

  requestWakeLock = async () => {
    if ('wakeLock' in navigator) {
      try {
        this.wakeLock = await navigator.wakeLock.request('screen')
        console.log(`wake lock acquired`)
      } catch (err) {
        console.error(`Error acquiring wake lock: ${err}`)
      }
    }
  }

  render() {
    return (
      <Provider RootStore={new stores.RootStore()}>
        <Routes/>
      </Provider>
    );
  }
}

export default Root



// WEBPACK FOOTER //
// ./src/Root.js